import Cookies from 'js-cookie';
import antdCN from 'ant-design-vue/lib/locale-provider/zh_CN';
const standardLangMap = {
    cn: 'zh_CN',
    en: 'en_US',
    zh_CN: 'zh_CN',
    en_US: 'en_US',
    'en-US': 'en_US',
    'zh-CN': 'zh_CN',
};
export const getLanguage = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang')
        || localStorage.getItem('wuji-user-lang')
        || Cookies.get('lang')
        || Cookies.get('language')
        || navigator.language
        || standardLangMap.cn;
    if (Object.keys(standardLangMap).includes(lang)) {
        return standardLangMap[lang];
    }
    return standardLangMap.cn;
};
export const writeLanguageConfig = (lang) => {
    const finalLang = standardLangMap[lang];
    if (!finalLang) {
        console.error(`[wuji-lang]不存在的语言key:${lang}, 可选的语言${Object.keys(standardLangMap).join(',')}`);
        return;
    }
    Cookies.set('lang', finalLang);
};
const getLanguageConfig = async (withTdesign) => {
    const lang = getLanguage();
    const languageMap = {
        tdesign: {
            [standardLangMap.en]: () => import('tdesign-vue/es/locale/en_US'),
            [standardLangMap.cn]: async () => ({ default: null }), // td 默认的就是 cn，不需要 import
        },
        antd: {
            [standardLangMap.en]: () => import('ant-design-vue/lib/locale-provider/en_US'),
            [standardLangMap.cn]: async () => ({ default: antdCN }),
        },
    };
    const loadPromise = [languageMap.antd[lang]?.()];
    if (withTdesign) {
        loadPromise.push(languageMap.tdesign[lang]?.());
    }
    const [antdLocale, tdesignLocale] = await Promise.all(loadPromise);
    return {
        antdLocale: antdLocale?.default,
        tdesignLocale: tdesignLocale?.default,
    };
};
export default getLanguageConfig;
